import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { API } from "src/store/dataService/types";
import { CreditIQTokenBundle } from "Types/api/CreditIQ";

/**
 * Get request
 */
export const getCIQTokenRequest = actionCreator(
    "ciq_token/get/request",
    (uuid: string, vin: string, afterFetch?: () => void) => ({ uuid, vin, afterFetch }),
    () => ({ route: API.CreditIQ })
);

/**
 * Get success
 */
export const getCIQTokenSuccess = actionCreator(
    "ciq_token/get/success",
    (vin: string, tokenBundle: CreditIQTokenBundle) => ({
        vin,
        tokenBundle,
    })
);

/**
 * Get failure
 */
export const getCIQTokenFailure = actionCreator("ciq_token/get/failure", (vin) => ({ vin }));
